<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c003">DEDICATION</a></p>
<p><a href="#/c004">Prologue</a></p>
<p><a href="#/c005">Chapter 1</a></p>
<p><a href="#/c006">Chapter 2</a></p>
<p><span href="#/c007" title="Link target outside of Sample">Chapter 3</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Chapter 4</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Chapter 5</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Chapter 6</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Chapter 7</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Chapter 8</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Chapter 9</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Chapter 10</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Chapter 11</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Chapter 12</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Chapter 13</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Chapter 14</span></p>
<p><span href="#/c019" title="Link target outside of Sample">Chapter 15</span></p>
<p><span href="#/c020" title="Link target outside of Sample">Chapter 16</span></p>
<p><span href="#/c021" title="Link target outside of Sample">Chapter 17</span></p>
<p><span href="#/c022" title="Link target outside of Sample">Chapter 18</span></p>
<p><span href="#/c023" title="Link target outside of Sample">Chapter 19</span></p>
<p><span href="#/c024" title="Link target outside of Sample">Epilogue</span></p>
<p><span href="#/c025" title="Link target outside of Sample">Sneak Preview of the New Dystopian Series | DESIRE | Book 1 | kailin gow</span></p>
<p><span href="#/c026" title="Link target outside of Sample">Prologue</span></p>
<p><span href="#/c027" title="Link target outside of Sample">Chapter 1 | </span></p>
<p><span href="#/c028" title="Link target outside of Sample">DESIRE</span></p>
<p><span href="#/c029" title="Link target outside of Sample">Beautiful Beings</span></p>
<p><span href="#/c030" title="Link target outside of Sample">Want More Edgy books like this one?</span></p>
<p><span href="#/c031" title="Link target outside of Sample">Sparklesoup | http://www.sparklesoup.com | Where you will find edgy books for teens, young adults, and new adults that would make your heart pound, your skin crawl, and leave you wanting more... | Feed Your Reading Addiction</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5e1c4a4f